module.exports = __webpack_public_path__ + "img/banner-default.c92bdb50.png";